import React from 'react'
import { DynamicTag, transformRegionToMap, ShowOnDesktop } from 'msp-components'
import { JasminSearchBox } from '@/components/organisms/JasminSearchBox'
import { ServiceSearchProps } from './ServiceSearch.types'
import * as S from './ServiceSearch.styles'

//todo: Remove the overlapping demo div (on line 13) when M23 tab module will get created
const ServiceSearch = ({ data, regions = [] }: ServiceSearchProps) => {
  const headlineText =
    transformRegionToMap(regions)?.get('headlineRegion')?.components || []
  return (
    <>
      <ShowOnDesktop className={'bg-offWhite h-36 w-full'}></ShowOnDesktop>
      <div className={S.serviceSearchContainer}>
        <div className={S.serviceSearchWrapper}>
          {headlineText.length && (
            <div className={S.dynamicTagWrapper}>
              <DynamicTag
                className={S.serviceSearchTitle}
                componentTagName='Headline'
                colorScheme='whiteAlpha'
                tag={headlineText[0].data?.tag || 'h3'}
                tagStyle={headlineText[0].data?.tagStyle || 'h6'}
              >
                {headlineText[0].data?.children}
              </DynamicTag>
            </div>
          )}
          <div
            className={S.searchBoxWrapper}
            data-testid='service-search-box-wrapper'
          >
            <JasminSearchBox
              className={S.searchBoxStyles}
              inputClassName={S.inputBoxStyle}
              inputPlaceholder={data?.SearchPlaceholder}
              iconColor={'#FFFFFF'}
              isDarkMode={true}
              classNameResults='bg-darkGray shadow-black shadow-xl text-white'
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ServiceSearch
